/*
 * @Author:
 * @Description:
 * @Date: 2024-11-20 19:21:18
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/risk/api/risk.js
 */
import Http from '@/utils/http/index';

// 获取黑白名单列表
export function queryRiskList(params) {
  return Http.get('/merRiskLibrary/queryLibName', { params });
}

// 获取黑白名单详情列表
export async function queryRiskDetailList(params) {
  const res = await Http.get('/merRiskLibrary/queryDetail', { params });
  if (res.content) {
    res.content = res.content.map(item => {
      item.status = (+item.status === 0); // 对数据格式做处理，防止数据格式不一致
      return item;
    });
  }
  return res;
};

export function addRiskLibName(data = {}) {
  return Http.post('/merRiskLibrary/addLibName', data);
}

export function updateRiskLibRuleStatus(data = {}) {
  return Http.post('/merRiskLibrary/editLibRule', data);
}

export function updateRiskLibRuleName(data = {}) {
  return Http.post('/merRiskLibrary/editLibAlias', data);
}

export function updateLibDetailStatus(data = {}) {
  return Http.post('/merRiskLibrary/editLibStatus', data);
}

export function batchAddRiskLibDetail(data = {}) {
  return Http.post('/merRiskLibrary/addDetailBatch', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function addRiskLibDetailById(data = {}) {
  return Http.post('/merRiskLibrary/addDetailById', data);
}
// merRiskLibrary/getLibSummary
export function getLibSummary(data = {}) {
  // riskLibraryId
  return Http.get('/merRiskLibrary/getLibSummary', { params: data });
}
// merRiskLibrary/batchEdit
export function batchEdit(data = {}) {
  return Http.post('/merRiskLibrary/batchEdit', data);
}
// merRiskLibrary/export
export function exportRiskLibDetail(data = {}) {
  return Http.post('/merRiskLibrary/export', data);
}
// merRiskLibrary/batchEditExpirationTime
export function batchEditExpirationTime(data = {}) {
  return Http.post('/merRiskLibrary/batchEditExpirationTime', data);
}
// merRiskLibrary/manualBatchAddByValues
export function manualBatchAddByValues(data = {}) {
  return Http.post('/merRiskLibrary/manualBatchAddByValues', data);
}
// merRiskLibrary/manualBatchAddByServiceIds
export function manualBatchAddByServiceIds(data = {}) {
  return Http.post('/merRiskLibrary/manualBatchAddByServiceIds', data);
}
